import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CountUp from 'react-countup';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { propStr, propNumber } from '../../../helpers/custom-prop-types';
import { usePrevious } from '../../../helpers/use/useHook';
const ConsultantSearchCountText = ({ className, total }) => {
    const prevTotal = usePrevious(total);
    // 初期描画のカウントアニメーションをdisabledに
    const start = isNullOrUndefinedOrEmpty(prevTotal) ? total : prevTotal;
    return (_jsxs("div", Object.assign({ className: `consultant-search-count-up ${className}` }, { children: [_jsx("span", Object.assign({ className: 'count-number' }, { children: _jsx(CountUp, { duration: 1, end: total, start: start }) })), _jsx("span", Object.assign({ className: 'count-unit' }, { children: "\u4EF6" })), _jsx("span", Object.assign({ className: 'count-hit' }, { children: "Hit!" }))] })));
};
ConsultantSearchCountText.propTypes = {
    className: propStr(),
    total: propNumber(),
};
ConsultantSearchCountText.defaultProps = {
    className: '',
    total: 0,
};
export default ConsultantSearchCountText;
